import React, { useEffect, useState, useMemo } from "react";
import Select from "react-select";
import { useSelector, useDispatch } from "react-redux";
import { getAllPhysician } from "../../../../store/slices/physicianSlice";
import { getPathologyServiceByClinic } from "../../../../store/slices/serviceSlice";
import { getClientPrice } from "../../../../store/slices/clientPriceSlice";

const Diagnostics = ({ handleChange, isClient, setFormData, formData }) => {
  const [selectedDiagnostics, setSelectedDiagnostics] = useState([]);
  const { physician } = useSelector((state) => state.physician);
  const { pathologyServices } = useSelector((state) => state.service);
  const { clientPrice } = useSelector((state) => state.clientPrice);
  const { clinicInfo } = useSelector((state) => state.clinic);
  const { token } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
const clinicId = clinicInfo?.[0]?.clinicId ||null;
  useEffect(() => {
    dispatch(
      getPathologyServiceByClinic({
        clinicId,
        token,
      })
    );
    dispatch(
      getAllPhysician({
        clinicId,
        clinicStatus: "Accepted",
        physicianStatus: "Accepted",
        token,
      })
    );
  }, [dispatch, clinicId, token]);

  // Fetch client prices when isClient or clientId changes
  useEffect(() => {
    if (isClient === "Yes" && formData.clientId) {
      dispatch(
        getClientPrice({
          clientId: formData.clientId,
          clinicId,
          token,
        })
      );
    }
  }, [isClient, formData.clientId, clinicId, token, dispatch]);

  // Merge client prices into pathologyServices
  const mergedServices = useMemo(() => {
    if (
      isClient === "Yes" &&
      Array.isArray(clientPrice) &&
      Array.isArray(pathologyServices)
    ) {
      const allClientDetails = clientPrice.flatMap(
        (item) => item.clientDetails
      );
      return pathologyServices.map((service) => {
        const clientDetail = allClientDetails.find(
          (detail) =>
            detail.itemId === service._id &&
            detail.itemType === service.testType
        );
        // Prefer client module price, then ClinicTestMaster/ClinicLabProfile clientPrice, then pt_price
        const fallbackClientPrice =
          service.clientPrice ?? service.client_price ?? undefined;
        return {
          ...service,
          effective_client_price:
            clientDetail && clientDetail.price != null
              ? clientDetail.price
              : fallbackClientPrice,
        };
      });
    }
    return pathologyServices || [];
  }, [isClient, clientPrice, pathologyServices]);

  const serviceOptions = useMemo(() => {
    return mergedServices?.map((s) => {
      const price =
        isClient === "Yes"
          ? s.effective_client_price ?? s.pt_price
          : s.pt_price;

      return {
        value: s._id,
        label: s.profileName || s.testName,
        type: s.testType,
        price, 
      };
    })
    .sort((a, b) =>
      a.label.localeCompare(b.label, undefined, {
        sensitivity: "base",
      })
    );
  }, [mergedServices, isClient]);

  // Recalculate total when isClient, client, or selectedDiagnostics changes
  useEffect(() => {
    if (!selectedDiagnostics.length) return;

    const updated = selectedDiagnostics.map((opt) => {
      const matched = serviceOptions.find((s) => s.value === opt.value);
      return {
        ...opt,
        price: matched?.price ?? 0,
      };
    });

    setSelectedDiagnostics(updated);
    handleSelectedDiagnosticPrice(updated);
  }, [isClient, serviceOptions]);
  const handleSelectedDiagnosticPrice = (selectedOptions) => {
    const options = selectedOptions || [];
    setSelectedDiagnostics(options);

    // prepare for serviceDetails
    const serviceDetails = options.map((service) => ({
      id: service.value,
      name: service.label,
      price: service.price ?? 0, // updated price
      type: service.type || "consultation",
    }));

    // update formData
    setFormData((prev) => ({
      ...prev,
      serviceDetails,
      totalAmount: serviceDetails.reduce((sum, s) => sum + (s.price || 0), 0),
    }));
  };

  return (
    <>
      <div className="col-xl-6">
        <div className="form-group">
          <label htmlFor="name" className="col-form-label">
            Service Details:
          </label>
          <Select
            options={serviceOptions}
            isMulti
            value={selectedDiagnostics}
            onChange={handleSelectedDiagnosticPrice}
            styles={{
              container: (provided) => ({ ...provided, marginTop: 8 }),
            }}
          />
        </div>
      </div>
      <div className="col-xl-6">
        <div className="form-group">
          <label htmlFor="name" className="col-form-label">
            Consulting Physician:
          </label>
          <Select
            options={physician?.map((physician) => ({
              value: physician?._id,
              label: physician?.userId?.name,
            }))}
            onChange={(e) => handleChange(e, "physician")}
            styles={{
              container: (provided) => ({ ...provided, marginTop: 8 }),
            }}
          />
        </div>
      </div>
      <div className="col-xl-6">
        <div className="form-group">
          <label htmlFor="total-amount" className="col-form-label">
            Total Amount:
          </label>
          <input
            type="number"
            className="form-control"
            id="total-amount"
            value={formData.totalAmount || 0}
            readOnly
          />
        </div>
      </div>
    </>
  );
};

export default Diagnostics;
